"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useAppSelector } from "@/store/hooks";
import { navigation } from "@/constants/navigation";

const Root = () => {
  const router = useRouter();
  const { getNavigationByPermissions } = useAuth();
  const user = useAppSelector(state => state.user.info);

  useEffect(() => {
    if (!user?.roles) return;
    const navigationByPermissions = getNavigationByPermissions(
      navigation,
      user.roles
    );
    const firstPath = navigationByPermissions[0]?.path;
    if (firstPath) {
      router.push(firstPath);
    }
  }, []);

  return <></>;
};

export default Root;
